export default __webpack_public_path__ + "static/media/22-MSCCruises-Logo.b8c39dcd.jpg";